import i18n from 'i18next';
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationHE from './locales/he/translation.json';
import translationAR from './locales/ar/translation.json';
import translationRU from './locales/ru/translation.json';
import { happenedCardsRaw, feelCardsRaw, needCardsRaw } from './static/cards';

const happenedCardsENTranslation = happenedCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]:
    {
      title: card.title,
      title_male: card.title_male,
      title_female: card.title_female,
      title_other: card.title_other,
      description: card.description,
      prefix: card.prefix
    }
  });
}, {});
const feelCardsENTranslation = feelCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]:
    {
      title: card.title,
      title_male: card.title_male,
      title_female: card.title_female,
      title_other: card.title_other,
      description: card.description,
      prefix: card.prefix
    }
  });
}, {});
const needCardsENTranslation = needCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]:
    {
      title: card.title,
      title_male: card.title_male,
      title_female: card.title_female,
      title_other: card.title_other,
      description: card.description,
      prefix: card.prefix
    }
  });
}, {});
const happenedCardsHETranslation = happenedCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]:
    {
      title: card[`titleHe`],
      title_male: card[`titleHe_male`],
      title_female: card[`titleHe_female`],
      title_other: card[`titleHe_other`],
      description: card[`descriptionHe`],
      prefix: card[`prefixHe`]
    }
  });
}, {});
const feelCardsHETranslation = feelCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]:
    {
      title: card[`titleHe`],
      title_male: card[`titleHe_male`],
      title_female: card[`titleHe_female`],
      title_other: card[`titleHe_other`],
      description: card[`descriptionHe`],
      prefix: card[`prefixHe`]
    }
  });
}, {});
const needCardsHETranslation = needCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]:
    {
      title: card[`titleHe`],
      title_male: card[`titleHe_male`],
      title_female: card[`titleHe_female`],
      title_other: card[`titleHe_other`],
      description: card[`descriptionHe`],
      prefix: card[`prefixHe`]
    }
  });
}, {});

// Arabic cards – prefer AR fields, fallback to HE, then EN
const happenedCardsARTranslation = happenedCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]: {
      title: card['titleAr'] || card['titleHe'] || card.title,
      title_male: card['titleAr_male'] || card['titleHe_male'] || card.title_male,
      title_female: card['titleAr_female'] || card['titleHe_female'] || card.title_female,
      title_other: card['titleAr_other'] || card['titleHe_other'] || card.title_other,
      description: card['descriptionAr'] || card['descriptionHe'] || card.description,
      prefix: card['prefixAr'] || card['prefixHe'] || card.prefix
    }
  });
}, {});

const feelCardsARTranslation = feelCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]: {
      title: card['titleAr'] || card['titleHe'] || card.title,
      title_male: card['titleAr_male'] || card['titleHe_male'] || card.title_male,
      title_female: card['titleAr_female'] || card['titleHe_female'] || card.title_female,
      title_other: card['titleAr_other'] || card['titleHe_other'] || card.title_other,
      description: card['descriptionAr'] || card['descriptionHe'] || card.description,
      prefix: card['prefixAr'] || card['prefixHe'] || card.prefix
    }
  });
}, {});

const needCardsARTranslation = needCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]: {
      title: card['titleAr'] || card['titleHe'] || card.title,
      title_male: card['titleAr_male'] || card['titleHe_male'] || card.title_male,
      title_female: card['titleAr_female'] || card['titleHe_female'] || card.title_female,
      title_other: card['titleAr_other'] || card['titleHe_other'] || card.title_other,
      description: card['descriptionAr'] || card['descriptionHe'] || card.description,
      prefix: card['prefixAr'] || card['prefixHe'] || card.prefix
    }
  });
}, {});

// russion cards
const happenedCardsRUTranslation = happenedCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]: {
      title: card['titleRu'] || card['titleHe'] || card.title,
      title_male: card['titleRu_male'] || card['titleHe_male'] || card.title_male,
      title_female: card['titleRu_female'] || card['titleHe_female'] || card.title_female,
      title_other: card['titleRu_other'] || card['titleHe_other'] || card.title_other,
      description: card['descriptionRu'] || card['descriptionHe'] || card.description,
      prefix: card['prefixRu'] || card['prefixHe'] || card.prefix
    }
  });
}, {});

const feelCardsRUTranslation = feelCardsRaw.reduce((memo, card) => {    
  return Object.assign(memo, {
    [card.title]: {
      title: card['titleRu'] || card['titleHe'] || card.title,
      title_male: card['titleRu_male'] || card['titleHe_male'] || card.title_male,
      title_female: card['titleRu_female'] || card['titleHe_female'] || card.title_female,
      title_other: card['titleRu_other'] || card['titleHe_other'] || card.title_other,
      description: card['descriptionRu'] || card['descriptionHe'] || card.description,
      prefix: card['prefixRu'] || card['prefixHe'] || card.prefix
    }
  });
}, {});

const needCardsRUTranslation = needCardsRaw.reduce((memo, card) => {
  return Object.assign(memo, {
    [card.title]: {
      title: card['titleRu'] || card['titleHe'] || card.title,
      title_male: card['titleRu_male'] || card['titleHe_male'] || card.title_male,
      title_female: card['titleRu_female'] || card['titleHe_female'] || card.title_female,
      title_other: card['titleRu_other'] || card['titleHe_other'] || card.title_other,
      description: card['descriptionRu'] || card['descriptionHe'] || card.description,
      prefix: card['prefixRu'] || card['prefixHe'] || card.prefix
    }
  });
}, {});

const RTL_LANGS = ['he', 'ar'];

const resources = {
  en: {
    translation: {
      ...translationEN,
      cards: {
        HAPPENED: happenedCardsENTranslation,
        FEEL: feelCardsENTranslation,
        NEED: needCardsENTranslation,
      }
    }
  },
  he: {
    translation: {
      ...translationHE,
      cards: {
        HAPPENED: happenedCardsHETranslation,
        FEEL: feelCardsHETranslation,
        NEED: needCardsHETranslation,
      }
    }
  },
  ar: {
    translation: {
      ...translationAR,
      cards: {
        HAPPENED: happenedCardsARTranslation,
        FEEL: feelCardsARTranslation,
        NEED: needCardsARTranslation,
      }
    }
  },
  ru: {
    translation: {
      ...translationRU,
      cards: {
        HAPPENED: happenedCardsRUTranslation,
        FEEL: feelCardsRUTranslation,
        NEED: needCardsRUTranslation,
      }
    }
  },
}

function applyLangAttributes(locale = 'en') {
  try {
    const dir = RTL_LANGS.includes(locale) ? 'rtl' : 'ltr';
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', locale);
      document.documentElement.setAttribute('dir', dir);
      document.body.setAttribute('lang', locale);
      document.body.setAttribute('dir', dir);
    }
  } catch (_) {
    // no-op for non-DOM environments
  }
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: `en`,
    debug: (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development'),
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      wait: true,
    },
    detection: {
      // Check localStorage first (returning users who already made a choice),
      // then fall back to the browser's own language setting for new users.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Keep DOM attributes in sync with i18n at all times
applyLangAttributes(i18n.language);
i18n.on('languageChanged', (lng) => applyLangAttributes(lng));


function changeLanguage(locale = `en`) {
  i18n.changeLanguage(locale);
  applyLangAttributes(locale);
  try {
    localStorage.setItem('i18nextLng', locale);
    localStorage.setItem('i18n:userSet', 'true');
  } catch (_) {}
}

export { i18n, changeLanguage };